export function getProductionStepId(card = {}) {
  const value = card.step_id ?? card.stepId ?? card.stepid;
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
}

export function getProductionDetailExternalKey(card = {}) {
  const raw = card.external_key || card.externalkey || card.externalKey || card.id;
  const parts = String(raw || '').split(/~|::/).map((part) => part.trim());
  if (parts.length !== 3 || parts.some((part) => !part)) return null;
  const [orderNumber, itemId, decorationId] = parts;
  if (!Number.isFinite(Number(itemId)) || !Number.isFinite(Number(decorationId))) return null;
  if (card.itemId != null && Number(card.itemId) !== Number(itemId)) return null;
  if (card.decorationId != null && Number(card.decorationId) !== Number(decorationId)) return null;
  return `${orderNumber}~${itemId}~${decorationId}`;
}

